import './LogbookBreadcrumbs.css';

import React from 'react';
import { Breadcrumbs, Link } from '@mui/material';
import { generateClassName } from '../../b2b-common/helpers';
import { Delete, Folder, Home, Http, MoreVert, PostAdd, UploadFile } from '@mui/icons-material';
import MoreButton from '../../b2b-common/MoreButton';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const LogbookBreadcrumbs = ({ logbook, folder = null, className = null, onFolderChange, onNewFolder, onNewFile, onNewNote, onNewLink, onDeleteLogbook }) => {

    const { t } = useB2BTranslation('b2b-logbook');

    const handleItemClick = (event) => {
        event.preventDefault();
        const folderId = Number(event.target.getAttribute('data-folder-id'));
        if (onFolderChange && (folderId !== folder?.logBookFolderId)) {
            onFolderChange(folderId);
        }
    }

    const handleNewFolder = () => {
        if (onNewFolder)
            onNewFolder();
    }

    const handleNewItem = () => {
        if (onNewFile)
            onNewFile();
    }

    const handleNewNote = () => {
        if (onNewNote)
            onNewNote();
    }

    const handleNewLink = () => {
        if (onNewLink)
            onNewLink();
    }

    const handleDeleteLogbook = () => {
        if (onDeleteLogbook)
            onDeleteLogbook();
    }

    return (
        <Breadcrumbs aria-label="breadcrumb" className={generateClassName('logbook', '-breadcrums-container', className)} >
            <Link color="inherit" href="#" onClick={handleItemClick} data-folder-id={0} className={generateClassName('logbook', '-breadcrums-item', className)}>
                <Home />
                {t('Root Folder')}
            </Link>
            {folder && folder.logBookFolderId > 0 &&
                <span className={generateClassName('logbook', '-breadcrums-item', className)}>
                    <Folder />
                    {folder.logBookFolderName}
                </span>
            }
            <MoreButton icon={<MoreVert />}
                buttons={[
                    // Can only add a new folder in the root folder
                    ...(folder === null ? [{
                        icon: <Folder />,
                        label: t('Add Folder'),
                        onClick: handleNewFolder,
                    }] : []),
                    {
                        icon: <UploadFile />,
                        label: t('Add File'),
                        onClick: handleNewItem
                    },
                    {
                        icon: <PostAdd />,
                        label: t('Add Note'),
                        onClick: handleNewNote
                    },
                    {
                        icon: <Http />,
                        label: t('Add Link'),
                        onClick: handleNewLink
                    },
                    {
                        icon: <Delete />,
                        label: t('Delete'),
                        rolesAllowed: ['ADMIN'],
                        onClick: handleDeleteLogbook,
                    }
                ]}
                dropPositionAlign='right'
                rolesAllowed={['ADMIN', 'EDITOR']}
                className={generateClassName('logbook', '-breadcrumb-more-button', className)}
                theme={'white-continuous'}
            />
        </Breadcrumbs>
    );
};

export default LogbookBreadcrumbs;